<template>
  <div>
    <div class="d-flex">
      <v-btn :disabled="ownActivities.length<=1" class="ml-auto" icon @click="onShowDragDropList">
        <v-icon>mdi-playlist-edit</v-icon>
      </v-btn>
      <v-btn :disabled="!activity || (!isDirector && !isOwn(activity))" icon @click="onDelete">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-btn icon class="gelb mr-2" @click="onAddNew">
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
    </div>
    <v-chip-group color="blue" v-model="bereich.index" column>
      <v-chip v-for="activity in activities" :key="(activity||{}).id||'null'">
        <v-icon>{{isOwn(activity) ? 'mdi-flag':'mdi-flag-outline'}}</v-icon>
        {{ (activity || {}).name }}
      </v-chip>
      <v-chip disabled v-if="activities.length===0">
        <v-icon color="silver">mdi-flag</v-icon>
        Keine Aktivitäten
      </v-chip>
    </v-chip-group>
    <drag-drop-list-dlg :list="ownActivities" :open="showDlg" text-key="name" id-key="id" @ok="onDragOk"
                        @cancel="showDlg=false"/>
  </div>
</template>

<script>
import Vue from 'vue'
import DragDropListDlg from "@/components/DragDropListDlg";

export default {
  name: "ActivityGroup",
  components: {DragDropListDlg},
  props: {
    'bereich': Object,
  },
  data() {
    return {
      showDlg:false,
    }
  },
  methods: {
    onAddNew() {
      this.$emit("add_new");
    },
    onDelete() {
      this.$events.$emit("ask", {
        title: 'Aktivität löschen?', yes_button: 'Löschen!', cancel_button: "Abbrechen",
        question: `Willst du die Aktivität '${this.activity.name}' löschen?`,
        onYes: () => this.$emit("delete", this.activity),
      });
    },
    onShowDragDropList() {
      this.showDlg = true;
    },
    onDragOk(modifiedActivities) {
      this.bereich.activities=modifiedActivities;
      this.showDlg=false;
      this.$emit("changed_order", this.bereich);
    },
    isOwn(a) {
      if (!a)
        return true;
      if (this.isDirector)
        return a.private;
      return (a.__owner__ === this.email);
    },
  },
  computed: {
    email() {
      return this.$app.user.email;
    },
    isDirector() {
      return this.$app.isDirector;
    },
    activity() {
      if (this.bereich.index < 0)
        return undefined;
      else
        return this.bereich.activities[this.bereich.index];
    },
    activities() {
      return this.bereich.activities;
    },
    ownActivities() {
      if (this.isDirector)
        return this.bereich.activities;
      return this.bereich.activities.filter(a=>this.isOwn(a));
    }
  },
  // watch: {
  //   'bereich.index'(n) {
  //     Vue.set(this.bereich, 'selected_activity', this.activity);
  //     //this.$emit("selection_changed", n);
  //   }
  // },
}
</script>

<style scoped>

</style>